// import api from '@/api/users/users';
import api from "@/api/users/users";

const loginUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .loginUser(payload)
      .then((response) => {
        context.commit("SET_USER_PROFILE", response);
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const logoutUser = (context) => {
  context.commit("SET_USER_PROFILE", undefined);
};
// new Promise((resolve, reject) => {
//   api
//     .logoutUser(payload)
//     .then((response) => {
//       context.commit('SET_USER_PROFILE', undefined);
//       resolve(response);
//     })
//     .catch((error) => {
//       console.error(error);
//       reject(error);
//     });
// });

const getUsers = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getUsers(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createUser(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const editUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .editUser(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteUser = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteUser(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getPartners = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getPartners(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getPartnersLogo = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getPartnersLogo(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const editPartner = (context, bodyFormData) =>
  new Promise((resolve, reject) => {
    api
      .editPartner(bodyFormData)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deletePartner = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deletePartner(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const changePassword = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .changePassword(payload)
      .then((response) => {
        context.commit("SET_USER_PROFILE", response);
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const forgotPassword = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .forgotPassword(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getConductors = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getConductors(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createConductor = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createConductor(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteConductor = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteConductor(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const editConductor = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .editConductor(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
const getOrders = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getOrders(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getUserOrder = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getUserOrder(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getWebshopUserType = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getWebshopUserType(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createWebshopUserType = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createWebshopUserType(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const editTicketBuyerType = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .editTicketBuyerType(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteTicketBuyerType = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteTicketBuyerType(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getTicketBuyers = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getTicketBuyers(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const addTicketBuyerTypeToTicketBuyer = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .addTicketBuyerTypeToTicketBuyer(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getSettingsForProvider = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getSettingsForProvider(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const createSettingsForProvider = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .createSettingsForProvider(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const updateSettingsForProvider = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .updateSettingsForProvider(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const deleteSettingsForProvider = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .deleteSettingsForProvider(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getUsedTickets = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getUsedTickets(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

const getOrderIcal = (context, payload) =>
  new Promise((resolve, reject) => {
    api
      .getOrderIcal(payload)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });

export default {
  loginUser,
  logoutUser,
  getUsers,
  createUser,
  editUser,
  deleteUser,
  getPartners,
  getPartnersLogo,
  editPartner,
  deletePartner,
  changePassword,
  forgotPassword,
  getConductors,
  createConductor,
  deleteConductor,
  editConductor,
  getOrders,
  getUserOrder,
  getWebshopUserType,
  createWebshopUserType,
  editTicketBuyerType,
  deleteTicketBuyerType,
  getTicketBuyers,
  addTicketBuyerTypeToTicketBuyer,
  getSettingsForProvider,
  createSettingsForProvider,
  updateSettingsForProvider,
  deleteSettingsForProvider,
  getUsedTickets,
  getOrderIcal,
};
